import { observer } from 'src/utils/mobx-react';
import {
    FilterData,
    FilterKey,
    FilterWrapper,
    ItemsWrapper,
} from 'src/components/AutomationTrading/AutomationItem/AutomationItem.style';
import React, { useState } from 'react';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { AutomationFilter, AutomationItemType } from 'src/components/AutomationTrading/AutomationTrading';
import { EditableData } from 'src/components/AutomationTrading/AutomationItem/EditableData';
import {
    getFieldValue,
    renderBetween,
} from 'src/components/AutomationTrading/AutomationItem/AutomationComponents/AutomationComponents';

type FiltersPropsType = {
    filters: Array<AutomationFilter>;
    automationItem: AutomationItemType;
};

class FiltersState {
    public stateValue: FormInputState<string, string>;

    public constructor(private readonly automationItem: AutomationItemType) {
        this.stateValue = FormInputState.new('');
    }

    public onSaveFiltersIn = (value: string): void => {
        console.log('value ', value);
        const actions = this.automationItem.actions[0];
        if (actions === undefined) {
            return;
        }
    };

    public onSaveFilterWhere = (value: string): void => {
        console.log('value ', value);
        const actions = this.automationItem.actions[0];
        if (actions === undefined) {
            return;
        }
        // const kind = actions.kind;

        // const parsedValue = JSON.parse(value);
        // console.log('parsedValue ', parsedValue);
        //
        // this.appState.trpcClient.client.automation.patchAutomationFeed.mutate({
        //     automationId: this.automationItem.id,
        //     requestBody: {
        //         actions: [{
        //             kind: kind,
        //             markets: {
        //                 filters: [
        //                     {
        //                         kind: 'where',
        //                         where: {
        //                             field: 'competitionIndex.metadata.countryCode',
        //                             operator: 'eq',
        //                             value: parsedValue
        //                         }
        //                     }
        //                 ]
        //             }
        //         }]
        //     }
        // });

        // this.error = null;
        // this.props.automationState.allAutomations.refresh();
    };
}

export const Filters = observer('Filters', (props: FiltersPropsType) => {
    const [state] = useState(new FiltersState(props.automationItem));

    const buildFilter = (filter: AutomationFilter): JSX.Element | null => {
        switch (filter.kind) {
            case 'between':
                return renderBetween(filter);
            case 'in':
                return (
                    <ItemsWrapper>
                        <FilterData>{filter.in.field}</FilterData>{' '}
                        <EditableData
                            onSave={state.onSaveFiltersIn}
                            initValueOrState={JSON.stringify(filter.in.values)}
                        />
                    </ItemsWrapper>
                );
            case 'where':
                return (
                    <ItemsWrapper>
                        <FilterData>{filter.where.field}</FilterData> <FilterData>{filter.where.operator}</FilterData>{' '}
                        <EditableData
                            initValueOrState={getFieldValue(filter.where.value)}
                            onSave={state.onSaveFilterWhere}
                        />
                    </ItemsWrapper>
                );
        }
        return null;
    };

    return (
        <>
            {props.filters.map((filter, index) => {
                return (
                    <FilterWrapper key={index}>
                        <FilterKey>{filter.kind}</FilterKey>
                        {buildFilter(filter)}
                    </FilterWrapper>
                );
            })}
            {/*<Button size='small' onClick={() => {}}>Add new rule</Button>*/}
            {/*<Select selectOptions={[{key: 'between', name: 'between'}, {key: 'in', name: 'in'}, {key: 'where', name: 'where'}]} stateValue={state.stateValue}></Select>*/}
        </>
    );
});
